export default {
      id: "chevron-thin-24-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "assets/iconset.svg#chevron-thin-24",
      toString: function () {
        return this.url;
      }
    }